import DatePicker from 'react-datepicker';
import moment from 'moment';
import _ from 'underscore';
import CurrentUser from '../../../lib/account/CurrentUser';

var DropDownOptions = require("components/utility/DropDownOptions");
var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var Glyphicon = require("components/utility/icons/Glyphicon");
var StudentMetrics = require("lib/data/StudentMetrics");
var AccountPlans = require("lib/account/AccountPlans");

var EditableGoals = function (props) {
	
	LuckyOrangeClient.tagComponent("EditableGoals");

	////// HELPER //////
	var isPremiumAccount = () => {
		return CurrentUser.get() && CurrentUser.isPremiumOrTrialAccount() || CurrentUser.role == "adminRole"
	}

	var getExpectationMetric = () => {
		return props.prefs.grade_level_expectations_metrics[props.gradeLevel ? props.gradeLevel : "5"]
	}

	////// METRICS //////
	if (isPremiumAccount()) {
		var defaultGoals = [...FREE_GOALS, ...PREMIUM_GOALS]
	} else {
		var defaultGoals = FREE_GOALS
	}

	// metrics that are assigned by admin
	var assignedExpectations = getExpectationMetric().filter(({ metric, goal }) => {
		return metric !== "quizzes-passed"
	})

	// metrics that are not currently assigned
	var notAssignedExpectations = _.filter(defaultGoals, (goal) => {
		return !_.includes(_.pluck(assignedExpectations, 'metric'), goal.metric)
	})

	// combine assigned and not assigned expectations
	var expectations = _.uniq(assignedExpectations.concat(notAssignedExpectations))

	////// GOAL MANIPULATORS //////
	// edits student goals
	var editStudentGoals = (editedMetric, editedGoal) => {
		var expectations = getExpectationMetric();
		var newExpectations = expectations.map(({ metric, goal }) => {
			if (metric === editedMetric) {
				return { metric, goal: editedGoal }
			} else {
				return { metric, goal };
			}
		})
		var gradeLevelExpectationsMetrics = {...props.prefs.grade_level_expectations_metrics}
		gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations
		props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics })
	}

	// adds new student goal
	var addStudentGoal = (metric, goal) => {
		var expectations = getExpectationMetric();
		var newExpectations = [...expectations, { metric: metric, goal: goal }]
		var gradeLevelExpectationsMetrics = {...props.prefs.grade_level_expectations_metrics}
		gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations
		props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics })
	}

	// removes student goal
	var removeStudentGoal = (metric) => {
		var expectations = getExpectationMetric();
		var newExpectations = _.compact(_.filter(expectations, (exp) => { return exp.metric !== metric }))
		var gradeLevelExpectationsMetrics = {...props.prefs.grade_level_expectations_metrics}
		gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations
		props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics })
	}

	// dispatch to either add or remove goal metric
	var updateSelectedGoals = (metric) => {
		if (_.size(assignedMetrics) >= 3 && !_.includes(assignedMetrics, metric)) {
			return false
		}

		if (_.includes(assignedMetrics, metric)) {
			removeStudentGoal(metric)
		} else {
			var defaultGoal = _.findWhere(defaultGoals, { metric: metric }).goal
			addStudentGoal(metric, defaultGoal)
		}
	}

	////// MORE HELPERS //////
	// helper for clarification
	var isStudentDisplay = props.student

	// helper for time period name
	var periodName = $wr.capitalize(
		$wr.Constants.PERIOD_TO_NAME[props.prefs.expectations_time_period]
	).toLowerCase();

	// helper to pull metrics
	var assignedMetrics = _.pluck(assignedExpectations, 'metric')


	// determines if metric should be read-only
	var disableInput = (metric) => {
		if (metric === "quizzes-passed") { return false }
		return _.size(assignedExpectations) >= 3 && !_.includes(assignedMetrics, metric)
	}

	// detrmines if metric checkbox should be checked
	var isChecked = (metric) => {
		return _.includes(assignedMetrics, metric)
	}

	// retuns id if indexKey is present
	var addID = (fieldType, metric) => {
		return props.indexKey ? { id: `${fieldType}-${metric}-${props.indexKey}` } : {}
	}

	var expectationTimePerodMatches = () => {
		return props.prefs.expectations_time_period == props.slExpectationTimePeriod
	}

	// determines if a metric is user-specific
	var isCustomMetric = (metric, goal) => {
		var expectation = _.findWhere(props.slExpectations, { metric: metric })
		return !expectation || !expectationTimePerodMatches() ? true : expectation['goal'] !== goal
	}

	////// SUPPLEMENTAL GOALS //////
	var renderGoal = ({ metric, goal }) => {
		var disableClass = disableInput(metric) ? 'disableClass' : ''

		if (metric !== "quizzes-passed") {
			var checkbox = <input className="goalMetricSelector"
				{...addID('checkbox', metric)}
				type="checkbox" checked={isChecked(metric)}
				onChange={(e) => updateSelectedGoals(metric)} />
		}

		if (isStudentDisplay && isCustomMetric(metric, goal)) {
			var tooltipText = "The goal differs from student list default"
			var iconText = metric !== "quizzes-passed" ? 'This goal differs from the class goal' : ''

			var userIcon = (
				<span>
					<Glyphicon className="userIcon" icon="user" dataTip={tooltipText} /> {iconText}
				</span>
			)
		}

		if (isChecked(metric) || metric === 'quizzes-passed') {
			var numbersOnlyInput = (
				<span>
					<NumbersOnlyInput value={parseInt(goal || 0)}
						{...addID('input', metric)}
						className="withFrequency"
						onChange={(e) => editStudentGoals(metric, parseInt(e.target.value || 0))} />
					<span className="frequency">
						/ {periodName} {userIcon}
					</span>
				</span>
			)
		}

		return (
			<label className={"inputPair " + disableClass} key={metric}>
				{checkbox}
				<span className="goalMeticText text">{StudentMetrics.getLabel(metric)}</span>
				{numbersOnlyInput}
			</label>
		);
	}

	var updateQuestionCount = (update) => {
		var gradeLevelQuestionCount = { ...props.prefs.grade_level_question_count}
		gradeLevelQuestionCount[props.gradeLevel] = {...gradeLevelQuestionCount[props.gradeLevel], ...update}
		props.onEditPrefs({"grade_level_question_count": gradeLevelQuestionCount})
	}

	var supplementalExpectations = expectations.filter(({ metric, goal }) => {
		return metric !== "quizzes-passed"
	})
	var supplementalGoalInputs = supplementalExpectations.map(renderGoal);

	////// QUIZ GOALS //////
	var quizExpectation = getExpectationMetric().find(({ metric, goal }) => {
		return metric === "quizzes-passed"
	})
	if (quizExpectation) {
		var quizGoalInput = renderGoal(quizExpectation);
	}

	var question_count = props.prefs.grade_level_question_count[props.gradeLevel ? props.gradeLevel : "5"]
	if (isPremiumAccount()) {
		var recallQuestionCount = question_count.recall_question_count
		var fitbInput = (
			<label className="inputPair">
				<span className="FITBSelector text">Fill-in-the-Blank</span>
				<select type="text" value={recallQuestionCount}
					{...addID('select', 'fitb')}
					onChange={(e) => updateQuestionCount({"recall_question_count": parseInt(e.target.value)}) }>
					{DropDownOptions.Select.RecallQuestionCount()}
				</select>
			</label>
		)
	}

	if (question_count.sentence_starter_count > 0) {
		var analysis_count = question_count.sentence_starter_count
		var sentence_starter = "On"
	} else {
		var analysis_count = question_count.analysis_question_count
		var sentence_starter = "Off"
	}

	var updateOpenEnded = (which, value) => {
		if (which === "question_count") {
			if (props.prefs.sentence_starter_count > 0) {
				updateQuestionCount({"sentence_starter_count": parseInt(value), "analysis_question_count": 0})
			} else {
				updateQuestionCount({"sentence_starter_count": 0, "analysis_question_count": parseInt(value)})
			}
		} else {
			if (value == "On") {
				updateQuestionCount({"sentence_starter_count": analysis_count, "analysis_question_count": 0})
			} else {
				updateQuestionCount({"sentence_starter_count": 0, "analysis_question_count": analysis_count})
			}
		}
	}

	var openEndedInput = (
		<label className="inputPair">
			<span className="text">Open-Ended</span>
			<select type="text" value={analysis_count}
				{...addID('select', 'open-ended')}
				onChange={(e) => updateOpenEnded("question_count", e.target.value)}>
				{DropDownOptions.Select.AnalysisQuestionCount()}
			</select>
		</label>
	)

	if (analysis_count > 0) {
		var sentenceStarterInput = (
			<label className="inputPair">
				<span className="text">Sentence Starters</span>
				<select type="text" value={sentence_starter}
					{...addID('select', 'sentence-starters')}
					onChange={(e) => updateOpenEnded("sentence_starter", e.target.value)}>
					{DropDownOptions.Select.SentenceStarter()}
				</select>
			</label>
		);
	}

	////// FREQENCY SELECTOR //////
	var selectStartOfWeek = (day) => {
		props.onEditPrefs({ "expectations_time_period_starts": [day] })
	}

	var selectStartDate = (periodStartPosition, periodStartDate) => {

		var newPeriodStartsArray = _.clone(props.prefs.expectations_time_period_starts);
		newPeriodStartsArray[periodStartPosition] = moment(periodStartDate).format("YYYY-MM-DD");
		props.onEditPrefs({ "expectations_time_period_starts": newPeriodStartsArray })
	}

	var selectTimePeriod = (timePeriod) => {
		if (timePeriod == $wr.Constants.PERIODS.WEEK) {
			var defaultPeriodStart = [0];
		} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
			var defaultPeriodStart = [1];
		} else {
			var startMonth = props.prefs.school_year_start_month;
			var currentYear = (new Date()).getFullYear();
			var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];

			if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
			}
		}
		var change = { 'expectations_time_period': timePeriod, 'expectations_time_period_starts': defaultPeriodStart }
		props.onEditPrefs(change)

	}

	var renderDatePickerForIndex = (index) => {
		return (
			<DatePicker className="startDatePicker"
				onChange={(date) => selectStartDate(index, date)} readOnly={true}
				selected={moment(props.prefs.expectations_time_period_starts[index])} />
		);
	}
	var renderFrequencyStartSelect = (frequencyType) => {
		var currentPeriodStarts = props.prefs.expectations_time_period_starts;

		if (frequencyType == $wr.Constants.PERIODS.WEEK) {
			var weekdayOptions = (
				DropDownOptions.Button.DaysOfWeek({
					includeWeeklyRange: true,
					buildOptionF: function (day) {
						return selectStartOfWeek.bind(this, day);
					}.bind(this)
				})
			);
			
			if ($wr.isValidDayOfWeek(currentPeriodStarts[0]) && $wr.isValidDayOfWeek((currentPeriodStarts[0] + 6) % 7) ) {
				var currentWeekdayText = $wr.getDayOfWeek(currentPeriodStarts[0]) + " - " + $wr.getDayOfWeek((currentPeriodStarts[0] + 6) % 7) || 0;
				var freqStartSelect = (
					<div className="periodStartSelector">
						<span className="periodSelectorLabel">From:</span>
						<ButtonDropdown text={currentWeekdayText}
							dropdownDisplay="link" className="formatControl">
							{weekdayOptions}
						</ButtonDropdown>
					</div>
				);
			}

		} else if (frequencyType == $wr.Constants.PERIODS.QUARTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Quarter 1 Starts:
					{renderDatePickerForIndex(0)}
					<br />
					Quarter 2 Starts:
					{renderDatePickerForIndex(1)}
					<br />
					Quarter 3 Starts:
					{renderDatePickerForIndex(2)}
					<br />
					Quarter 4 Starts:
					{renderDatePickerForIndex(3)}
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.TRIMESTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Trimester 1 Starts:
					{renderDatePickerForIndex(0)}
					<br />
					Trimester 2 Starts:
					{renderDatePickerForIndex(1)}
					<br />
					Trimester 3 Starts:
					{renderDatePickerForIndex(2)}
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.SEMESTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Semester 1 Starts:
					{renderDatePickerForIndex(0)}
					<br />
					Semester 2 Starts:
					{renderDatePickerForIndex(1)}
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.SCHOOL_YEAR) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					School Year Starts:
					{renderDatePickerForIndex(0)}
				</div>
			);
		} else {
			var freqStartSelect = <span></span>;
		}

		return freqStartSelect;
	}

	var renderFrequencySelector = (frequencyText, frequencyType) => {
		var currentlySelected = (props.prefs.expectations_time_period == frequencyType);
		if (currentlySelected) {
			var startSelect = renderFrequencyStartSelect(frequencyType);
		}
		return (
			<span className='inputFrequency' key={frequencyText}>
				<span className="formOption">
					<input type="radio" className="frequencyRadioBtn" checked={currentlySelected}
						{...addID('radio', `${frequencyType}`)}
						onChange={(e) => selectTimePeriod(frequencyType)} />
					<span>{frequencyText}</span>
				</span>
				{startSelect}
			</span>
		);
	}

	var showHeader = () => {
		return !props.hideHeader || props.hideHeader == false
	}

	////// RENDER METHODS //////
	if (props.quiz) {
		var quizDisplay = (
			<div className='goalSectionContainer'>
				<div className="studentSectionHeader">Quizzes</div>
				{quizGoalInput}
				{fitbInput}
				{openEndedInput}
				{sentenceStarterInput}
			</div>
		)
	}

	if (props.supplemental) {
		var supplementalDisplay = (
			<div className='goalSectionContainer'>
				<div className="studentSectionHeader">Supplemental</div>
				{supplementalGoalInputs}
			</div>
		)
	}


	if (props.periodSelector) {
		if (showHeader(props)) {
			var header = <div className="studentSectionHeader">Time Period</div>
		}
		var frequencySelectorDisplay = (
			<div className='goalSectionContainer'>
				{ header }
				<div>
					{renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK)}<br />
					{renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH)}<br />
					{renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER)}<br />
					{renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER)}<br />
					{renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER)}<br />
					{renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR)}<br />
				</div>
			</div>
		)
	}

	return (
		<div>
			{quizDisplay}
			{supplementalDisplay}
			{frequencySelectorDisplay}
		</div>
	)
};

var FREE_GOALS = [
	{ goal: 4, metric: "questions" },
	{ goal: 4, metric: "reviews" },
	{ goal: 2, metric: "question-builder" },
	{ goal: 10, metric: "days-active" },
];

var PREMIUM_GOALS = [
	{ goal: 2, metric: 'exercises' },
	{ goal: 100, metric: 'minutes' },
	{ goal: 100, metric: 'pages' },
];

EditableGoals.propTypes = StrictPropTypes({
	prefs: PropTypes.object.isRequired,
	gradeLevel: PropTypes.string,
	onEditPrefs: PropTypes.func.isRequired,
	supplemental: PropTypes.bool,
	hideHeader: PropTypes.bool,
	quiz: PropTypes.bool,
	periodSelector: PropTypes.bool,
	student: PropTypes.bool,
	slExpectations: PropTypes.array,
	slExpectationTimePeriod: PropTypes.string,
	indexKey: PropTypes.number,
});

module.exports = EditableGoals;



// WEBPACK FOOTER //
// ./modules/components/org/roster/EditableGoals.js